import { isString, words, deburr, capitalize, trim, flow } from 'lodash'

type SanitizeFlags = {
  allowLeadingDigits?: boolean
  allowHyphens?: boolean
  mapWord?: (word: string, index: number) => string
  wordSeparator?: string
}

const sanitizeWord = (word: string, index: number): string =>
  stripNonAsciiAlphaNumeric(deburr(transformWordToCamelCase(word, index)))

const transformWordToCamelCase = (word: string, index: number): string =>
  index > 0 ? capitalize(word) : word.toLowerCase()

const stripNonAsciiAlphaNumeric = (string: string): string =>
  string.replace(/[^\dA-Za-z]/g, '')

const removeLeadingDigits = (string: string): string =>
  string.replace(/^\d+/, '')

const sanitizePiece =
  (flags: SanitizeFlags) =>
  (string: string): string =>
    words(string)
      .map(flags.mapWord ? flags.mapWord : sanitizeWord)
      .join(flags.wordSeparator || '')

const sanitizeString =
  (flags: SanitizeFlags) =>
  (string: string): string =>
    string.replace(
      flags.allowHyphens ? /[^-_]+/g : /[^_]+/g,
      sanitizePiece(flags),
    )

export const sanitizeFieldKey = (
  value: string,
  flags: SanitizeFlags = {},
): string =>
  isString(value)
    ? flow([
        trim,
        flags.allowLeadingDigits ? (s: string) => s : removeLeadingDigits,
        sanitizeString(flags),
      ])(value)
    : ''
